<template>
  <div class="order">
    <div class="filter-container">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="85px">
        <el-form-item label="索赔单号">
          <el-input v-model="searchForm.claimStatementNum" placeholder="请输入索赔单号"></el-input>
        </el-form-item>
        <el-form-item label="索赔单状态">
          <el-select v-model="searchForm.status" filterable clearable placeholder="请选择状态">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="VIN">
          <el-input v-model="searchForm.vin" placeholder="请输入VIN"></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="searchForm.carBrand" placeholder="请输入品牌"></el-input>
        </el-form-item>
        <el-form-item label="车型">
          <el-input v-model="searchForm.carModel" placeholder="请输入车型"></el-input>
        </el-form-item>
        <el-form-item label="国家">
          <el-select filterable clearable v-model="searchForm.country" placeholder="请选择国家">
            <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户账号">
          <el-input v-model="searchForm.customerAccountNum" placeholder="请输入客户账号"></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="searchForm.customerName" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="searchForm.applyDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" plain @click="handleResetQuery">重置</el-button>
      </el-form>
    </div>
    <div class="table-container">
      <div class="table-btn">
        <el-button type="text" icon="el-icon-download" @click="handleExport" > 导出 </el-button>
      </div>
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
      >
        <el-table-column
          type="selection"
          width="40"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="claimStatementNum"
          label="索赔单号"
          align="center"
          min-width="120"
        >
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称"
          min-width="130"
        >
        </el-table-column>
        <el-table-column
          prop="status"
          label="审核状态"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span :class="'status' + scope.row.status">
              {{ getStatus(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerAccount"
          label="客户账号"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="countryName"
          label="国家"
          align="center"
          min-width="100"
        >
<!--          <template slot-scope="scope">-->
<!--            {{ getCountryName(scope.row.country) }}-->
<!--          </template>-->
        </el-table-column>
        <el-table-column
          prop="vinCount"
          label="VIN数量"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          width="160"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="审核时间"
          width="160"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime ? scope.row.updateTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="160px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleView(scope.row)"
            >查看</el-button>
            <el-button
              v-if="scope.row.status === 1"
              type="text"
              @click="handleAudit(scope.row)"
            >审核</el-button>
            <el-button
              v-if="scope.row.status === 3"
              type="text"
              @click="handleSettlement(scope.row)"
            >结算</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getSession } from "@/util/localStor";
import { getNations } from "@/util/getNation";
import { activityClaimList, activityClaimExport, activityClaimUpdateStatus, kdactivityClaimList, kdactivitySupportDelete } from "@/api/seek";
import { getDownloadFiles } from "@/util/downFile";

export default {
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      nationList: [],
      statusList: [
        { id: 0, name: "草稿" },
        { id: 1, name: "待审核" },
        { id: 2, name: "已驳回" },
        { id: 3, name: "待结算" },
        { id: 4, name: "已结算" },
        { id: 5, name: "已取消" },
        { id: 6, name: "已撤回" }
      ],
      searchForm: {
        claimStatementNum: '',
        status: '',
        vin: '',
        carBrand: '',
        carModel: '',
        country: '',
        customerAccountNum: '',
        customerName: '',
        applyDateRange: []
      },
      searchInfo: {}
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
    this.getList();
  },
  methods: {
    getStatus(status) {
      const item = this.statusList.find(s => s.id === status);
      return item ? item.name : '';
    },
    getCountryName(code) {
      if (!code) return '';
      return getNations(code);
    },
    handleSearch() {
      let params = { ...this.searchForm };
      if (params.applyDateRange && params.applyDateRange.length === 2) {
        params.createTimeStart = params.applyDateRange[0];
        params.createTimeEnd = params.applyDateRange[1];
      }
      delete params.applyDateRange;
      this.searchInfo = params;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    handleResetQuery() {
      this.searchForm = {
        claimStatementNum: '',
        status: '',
        vin: '',
        brand: '',
        model: '',
        country: '',
        customerAccountNum: '',
        customerName: '',
        applyDateRange: []
      };
      this.handleSearch();
    },
    async getList() {
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await activityClaimList(query);
      if (res.status == 0) {
        this.tableData = res.data.records || [];
        this.total = res.data.count || 0;
      }
    },
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    handleView(row) {
      this.$router.push({
        path: '/car-activityClaimDetail',
        query: { activityClaimId: row.activityClaimId || row.id }
      });
    },
    handleAudit(row) {
      this.$router.push({
        path: '/car-activityClaimDetail',
        query: { activityClaimId: row.activityClaimId || row.id, mode: 'audit' }
      });
    },
    handleSettlement(row) {
      this.currentDeleteRow = row;
      this.$confirm("确认结算" + row.claimStatementNum + "并下发至客户端?", "结算", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        activityClaimUpdateStatus({data: {activityClaimId: row.activityClaimId,status: 4 }}).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("结算成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });



      // this.$router.push({
      //   path: '/car-activityClaimDetail',
      //   query: { activityClaimId: row.activityClaimId || row.id, mode: 'settlement' }
      // });
    },
    // 导出
    async handleExport() {
      let params = { ...this.searchForm };
      if (params.applyDateRange && params.applyDateRange.length === 2) {
        params.createTimeStart = params.applyDateRange[0];
        params.createTimeEnd = params.applyDateRange[1];
      }
      delete params.applyDateRange;
      const query = {
        data: params
      };
      const res = await activityClaimExport(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！");
      }
    }
  }
};
</script>

<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.status0 {
  color: #909399;
}
.status1 {
  color: rgb(238,149,22)
}
.status2 {
  color: rgb(243,72,72)
}
.status3 {
  color: rgb(24, 144, 255);
}
.status4 {
  color: rgb(0, 136, 0)
}
.status5 {
  color: #909399;
}
</style>
